import React, { useState } from 'react';
import axios from 'axios';
import './VideoUpload.css';

//const baseurl = 'http://locahost:5000/upload';
const baseurl = 'http://54.208.53.142:5003/upload';

function VideoUpload({ onUploadSuccess }) {
    const [file, setFile] = useState(null);
    const [objectType, setObjectType] = useState('person');
    const [textType, setTextType] = useState('standard');
    const [musicType, setMusicType] = useState('happy');
    const [textSubtitle, setTextSubtitle] = useState(''); // State to store the subtitle text
    const [vendorID, setVendorID] = useState(''); // State to store the subtitle text
    const [isLoading, setIsLoading] = useState(false); // State to manage loading status

    const objectTypes = [
        'person', 'bicycle', 'car', 'motorcycle', 'airplane', 'bus', 'boat',
        'bird', 'cat', 'dog', 'umbrella', 'handbag', 'tie',
        'sports ball', 'scissor', 'tennis racket', 'bottle', 'wine glass', 'cup',
        'knife', 'banana', 'apple', 'sandwich', 'orange', 'broccoli',
        'pizza', 'chair', 'couch', 'tv', 'laptop', 'cell phone',
        'microwave', 'book', 'clock', 'skateboard'
    ];

    const musicTypes = [
        'happy', 'neutral', 'tense'
    ];

    const textTypes = [
        'standard', 'sarcastic', 'tense', 'selected object'
    ];

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleObjectTypeChange = (event) => {
        setObjectType(event.target.value);
    };

    const handleTextSubtitleChange = (event) => {
        setTextSubtitle(event.target.value);
    };

    const handleUpload = async () => {
        if (!file) {
            alert('Select a file...');
            return;
        }

        if (!textSubtitle) {
            alert('Write a text to subtitle...');
            return;
        }

        setIsLoading(true); // Start loading

        const formData = new FormData();
        formData.append('file', file);
        formData.append('object_type', objectType);
        formData.append('text_subtitle', textSubtitle); // Include text_subtitle in formData

        try {
            const response = await axios.post(baseurl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            onUploadSuccess(response.data.download_urls, response.data.codetime);
        } catch (error) {
            console.error('Error while uploading the file:', error);
        } finally {
            setIsLoading(false); // Stop loading irrespective of the result
        }
    };

    return (
        <div className="upload-container">
            <div className="file-upload">
                <input type="file" onChange={handleFileChange} />
            </div>
            <p>Object to find:</p>
            <div className="object-types">
                {objectTypes.map((type) => (
                    <div key={type} className="radio-button">
                        <input 
                            type="radio" 
                            id={type} 
                            name="objectType" 
                            value={type} 
                            checked={objectType === type}
                            onChange={handleObjectTypeChange} 
                        />
                        <label htmlFor={type}>{type}</label>
                    </div>
                ))}
            </div>
            <p>Music type:</p>
            <div className="music-selection">
                {musicTypes.map((type) => (
                    <div key={type} className="radio-button">
                        <input 
                            type="radio" 
                            id={type} 
                            name="musicType" 
                            value={type} 
                            checked={musicType === type}                            
                        />
                        <label htmlFor={type}>{type}</label>
                    </div>
                ))}
            </div>
            <p>Text from VOD-CORE:</p>
            <div className="vodcore-container">
                <div>
                    <label htmlFor="vendorID">Based on synopsis (Vendor ID):</label>
                    <input 
                        type="text" 
                        id="vendorID" 
                        value={vendorID} 
                        
                    />
                    <button>search</button>
                </div>
                <div>
                <p>AI creation:</p>
                <div className="object-types">
                    {textTypes.map((type) => (
                        <div key={type} className="radio-button">
                            <input 
                                type="radio" 
                                id={type} 
                                name="textType" 
                                value={type} 
                                checked={textType === type}                            
                            />
                            <label htmlFor={type}>{type}</label>
                        </div>
                    ))}
                </div>
            </div>
            </div>
            <br/>
            <div className="text-subtitle">
                <label htmlFor="textSubtitle">Manual Text:</label>
                <input 
                    type="text" 
                    id="textSubtitle" 
                    value={textSubtitle} 
                    placeholder='Text to subtitle'
                    onChange={handleTextSubtitleChange} 
                />
            </div>
            <br/>
            <button className="upload-btn" onClick={handleUpload} disabled={isLoading}>
                {isLoading ? '*** Processing ***' : 'Upload'}
            </button>
        </div>
    );
}

export default VideoUpload;
